import SpriteSymbol from "../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/_svg-sprite-loader@5.2.1@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-tu_arrow_left",
  "use": "icon-tu_arrow_left-usage",
  "viewBox": "0 0 34 34",
  "content": "<symbol viewBox=\"0 0 34 34\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-tu_arrow_left\">\n    <!-- <rect width=\"34\" height=\"34\" rx=\"6\" fill=\"#F3F5F9\"/> -->\n    <path d=\"M19 11L13 17L19 23\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n    </symbol>"
});
var result = sprite.add(symbol);
export default symbol